/* eslint-disable @typescript-eslint/no-var-requires */
import './store';
import { DialogView } from '@hb/coffee';
import { namespace } from 'vuex-class';
import NavBar from '@/components/nav-bar-coffee/index.vue';
import {
  Component, Prop, Mixins, InjectReactive,
} from 'vue-property-decorator';
import { OrdersV2 } from '@/api/ordersV2/types';
import { OrderStatusV2Enum, OrderResultEnum } from '@/enums/orderV2';
import wechat from '@/api/native/wechat';
import RouterHelper from '@/shared/utils/routerHelper';
import { Route } from 'vue-router';
import FinanceBusiness from '@/mixins/finance-business';
import { setPageTitle, openThirdPage } from '@/api/native/utils';
import platform, { appVersion } from '@/shared/utils/platform';
import {
  customServiceUrl, isH5App, isMockEnv, isIPOrigin,
} from '@/constant';

import AdvApplySuccessPopup from '@/components/adv-components/adv-apply-success-popup';
import AdvApplyFailPopup from '@/components/adv-components/adv-apply-fail-popup';
import LoadingAnimate from '@/widgets/loading-animate/index.vue';
import { jumpToMarketPage } from '@/shared/utils/jumpToRedirectPage';
import {
  queryMiddleIncomeCreditResult,
  queryMiddleIncomeContractList,
  queryMiddleIncomeDispatch,
} from '@/api/middle-income';
import {
  PageStatusEnum,
  CreditMallFromEnum,
  AgreementStyleEnum,
  MiddleIncomeDispatchResponse,
  MiddleIncomeContractListResponse,
  MiddleIncomeCreditResultResponse,
  MiddleIncomeContractListParams,
  MiddleIncomeContractSceneEnum,
  MiddleIncomeCreditApplyResponse,
} from '@/api/middle-income/types';
import { dcCreditSceneEnum } from '@/api/preApplyChoose/types';

import { homeStoreActions } from '@/pages/home/store';
import { PageSceneEnum } from '@/api/common/types';
import ApplyProcess from './components/apply-process';
import ApplyFail from './components/apply-fail';
import ApplySuccess from './components/apply-success';
import type { UbtConfig } from './types';
import '@/views_v2/home/store';
import './apply-result.theme.blue.scss';

/** 内嵌协议模块（异步） */
// eslint-disable-next-line @typescript-eslint/no-unsafe-return, @typescript-eslint/no-explicit-any
const FqMallEmbeddedProtocol = () => import('@/widgets/middle-income-contract/ContractCard.vue') as any;
/** 全屏协议模块（异步） */
// eslint-disable-next-line @typescript-eslint/no-unsafe-return, @typescript-eslint/no-explicit-any
const FqMallFullScreenProtocol = () => import('@/widgets/middle-income-contract/ContractPop.vue') as any;
/** 轮询卡片（异步） */
// eslint-disable-next-line @typescript-eslint/no-unsafe-return, @typescript-eslint/no-explicit-any
const InstallmentMall = () => import('@/widgets/middle-income-card/index.vue') as any;

const POLLING_INTERVAL = 5 * 1000;
/** 提现结果页中收默认入参（多处复用） */
const DEFAULT_MIDDLE_INCOME_SCENE = dcCreditSceneEnum.NO_CHANNEL_AVAILABLE;
const DEFAULT_MIDDLE_INCOME_FROM = CreditMallFromEnum.FINANCE_WITHDRAW_AGREEMENT;
const style = require('./index.module.scss') as Dictionary;

// eslint-disable-next-line max-len
// eslint-disable-next-line @typescript-eslint/no-explicit-any, @typescript-eslint/no-unsafe-assignment
const LoadingAnimateComp = LoadingAnimate as any;

const ApplyResultStore = namespace('applyResult');
const HomeStore = namespace('home');

Component.registerHooks([
  'beforeRouteEnter',
  'beforeRouteLeave',
  'beforeRouteUpdate',
]);
@Component({
  components: {
    FqMallEmbeddedProtocol,
    FqMallFullScreenProtocol,
    InstallmentMall,
  },
})
export default class ApplyResult extends Mixins(FinanceBusiness) {
  @InjectReactive() isShowH5Nav: boolean | undefined = undefined;

  // 提现申请apply接口直接返回失败的情况下，不存在orderId
  @Prop(String) readonly orderId?: string;

  @Prop(String) readonly commodityId!: string;

  @Prop(String) readonly commodityName!: string;

  @Prop(String) readonly financeVipType!: string;

  @Prop(String) readonly pricingType?: string;

  @ApplyResultStore.State orderDetail!: OrdersV2.OrderDetail | null;

  @ApplyResultStore.State showMoreCapitalInfo!: boolean;

  @ApplyResultStore.Action getApplyResult!: (
    payload: { orderId: string; showLoading?: boolean }
  ) => Promise<void>;

  @HomeStore.Action getUserAutarkyState!: () => Promise<boolean>;

  // 轮询引用
  private pollingId: NodeJS.Timer | null = null;

  // 返回挽留弹窗是否可见
  private isBackDialogVisible = false;

  // 返回挽留弹窗是否已展示过，保证只展示一次
  private hasShowedBackDialog = false;

  /** 商城相关字段- start */
  /** 是否显示分期商城内嵌协议模块 方案1-A 样式 */
  private isShowFqMallEmbeddedProtocol = false;

  /** 是否显示分期商城全屏协议模块 方案2-B 样式 */
  private isShowFqMallFullScreenProtocol = false;

  /** 是否显示分期商城轮询卡片 授信状态为 授信提交中，授信成功时展示 */
  private isShowFqMallPollingCard = false;

  private middleIncomeDispatchData: MiddleIncomeDispatchResponse | undefined = undefined;

  private middleIncomeContractListData: MiddleIncomeContractListResponse | undefined = undefined;

  private middleIncomeCreditResultData: MiddleIncomeCreditResultResponse | undefined = undefined;

  /** 中收授信申请任务ID（用于透传轮询卡片） */
  private middleIncomeTaskId = '';

  /** 商城相关字段- end */

  /** 协议是否已加载完成 */
  private loadingComplete = false;

  /** 显示loading页 */
  private get showLoadingAnimate(): boolean {
    return (!!platform.isEasyBike || isMockEnv || isIPOrigin) && !this.loadingComplete;
  }

  // 协议加载完成后关闭loading
  private onLoadAgreements() {
    /** 如果显示loading，则关闭loading */
    if (this.showLoadingAnimate) {
      this.loadingComplete = true;
    }
  }

  private ubtConfig:Dictionary<UbtConfig> = {
    [OrderResultEnum.LENDING]: {
      exposeName: 'finance_drawresultprocess',
      backName: 'finance_drawresultprocess_return',
    },
    [OrderResultEnum.LEND_FAILED]: {
      exposeName: 'finance_drawresultfail',
      backName: 'finance_drawresultfail_return',
    },
    [OrderResultEnum.LENT]: {
      exposeName: 'finance_drawresultpass',
      backName: 'finance_drawresultpass_return',
    },
  }

  // 业务申请订单状态映射
  private get applyStatus(): OrderResultEnum | undefined {
    if (!this.orderId || this.orderId === 'undefined') {
      return OrderResultEnum.LEND_FAILED;
    }

    const { state, loanOrderId } = this.orderDetail || {};

    // 阻止store数据缓存上次数据，导致页面渲染异常
    if (!state || !loanOrderId || loanOrderId !== this.orderId) {
      return undefined;
    }
    if (
      [
        OrderStatusV2Enum.REJECTED,
        OrderStatusV2Enum.CANCELLED,
        OrderStatusV2Enum.LEND_FAILED,
      ].indexOf(state) >= 0
    ) {
      return OrderResultEnum.LEND_FAILED;
    }
    if (state === OrderStatusV2Enum.LENT) {
      return OrderResultEnum.LENT;
    }
    return OrderResultEnum.LENDING;
  }

  private async created() {
    if (this.orderId) {
      try {
        const promises = [
          /** 获取自营状态 */
          this.getUserAutarkyState(),
          /** 提现结果页拉取海消展示状态 */
          homeStoreActions.getHaiXiaoQueryStatusResult(PageSceneEnum.APPLY_RESULT),
          /** 查询订单状态 */
          this.startPolling(this.orderId),
        ];
        /** 只在 easybike 环境下 或者mock环境 调用 */
        if (platform.isEasyBike || isMockEnv || isIPOrigin) {
          promises.push(this.getWithdrawResultSummary());
        }
        await Promise.all(promises);
        /** 出结果以后，再移除loading动画 */
        this.onLoadAgreements();
      } catch (error) {
        /** 获取数据异常，则直接关闭loading动画 */
        this.onLoadAgreements();
      }
    } else {
      /** 没有orderId，则直接关闭loading动画 */
      this.onLoadAgreements();
    }
  }

  private async getWithdrawResultSummary() {
    // 1. 先查询中收授信结果
    try {
      this.middleIncomeCreditResultData = await queryMiddleIncomeCreditResult({
        scene: DEFAULT_MIDDLE_INCOME_SCENE,
        from: DEFAULT_MIDDLE_INCOME_FROM,
        version: appVersion || '5.13.0',
      });
    } catch {
      // 授信结果查询失败，继续执行后续流程
    }

    // 2. 根据授信结果状态，判断是否需要调用分发接口
    // 如果授信结果成功，则展示商城轮询卡片
    // eslint-disable-next-line @typescript-eslint/no-unsafe-assignment
    const creditStatus = this.middleIncomeCreditResultData?.status;
    if (creditStatus === PageStatusEnum.SUCCEEDED || creditStatus === PageStatusEnum.PROCESSING) {
      this.isShowFqMallPollingCard = true;
      return;
    }

    // 如果授信结果不成功，则需要调用分发接口
    const needDispatch = creditStatus === PageStatusEnum.FAILED
    || creditStatus === undefined || creditStatus === PageStatusEnum.INIT;

    if (needDispatch) {
      try {
        // 3. 查询中收分发结果
        this.middleIncomeDispatchData = await queryMiddleIncomeDispatch({
          pageScene: 'loanResultPageDispatch',
          /** 提现结果页 资料肯定完整，默认传false */
          incompleteInfo: false,
          businessInfo: {
            scene: DEFAULT_MIDDLE_INCOME_SCENE,
            from: DEFAULT_MIDDLE_INCOME_FROM,
          },
        });

        // 4. 查到分发数据以后，根据协议样式展示协议模块
        if (this.middleIncomeDispatchData) {
          const {
            agreementStyle,
            shoppingMallCommodities,
            overLoanCommodities,
          } = this.middleIncomeDispatchData;
          // 4.1 根据分发结果查询协议列表（商城/半流程）
          try {
            const pickCommodityIds = (list?: { commodityId: string }[]): string[] => (
              (list || []).map((i) => i.commodityId)
            );

            const shoppingMallCommodityIds = pickCommodityIds(shoppingMallCommodities);
            const overLoanCommodityIds = pickCommodityIds(overLoanCommodities);

            // 商城或半流程任一有产品信息时，才查询协议
            if (shoppingMallCommodityIds.length > 0 || overLoanCommodityIds.length > 0) {
              const params: MiddleIncomeContractListParams = {};
              if (shoppingMallCommodityIds.length > 0) {
                params.shoppingMallCommoditys = shoppingMallCommodityIds;
              }
              if (overLoanCommodityIds.length > 0) {
                params.overLoanCommoditys = overLoanCommodityIds;
              }
              this.middleIncomeContractListData = await queryMiddleIncomeContractList(
                {
                  scene: MiddleIncomeContractSceneEnum.CREDIT,
                  ...params,
                },
              );

              /** 查到协议后，再展示协议模块 */
              if (agreementStyle === AgreementStyleEnum.SCHEME_A) {
                this.isShowFqMallEmbeddedProtocol = true;
              } else if (agreementStyle === AgreementStyleEnum.SCHEME_B) {
                this.isShowFqMallFullScreenProtocol = true;
              }
            }
          } catch {
            // 协议查询失败不影响主流程
          }
        }
      } catch {
        // 分发接口调用失败不影响主流程
      }
    }
  }

  // 提现失败时离开页面时显示提现渠道挽留弹窗
  private beforeRouteLeave(
    to: Route,
    from: Route,
    next: (...d: unknown[]) => void,
  ) {
    const isBack = RouterHelper.isBackOnce();
    // 点击返回时，触发click
    if (this.applyStatus) {
      const { backName } = this.ubtConfig[this.applyStatus] || {};
      this.$ubtPageButton(backName);
    }

    /** 如果显示全屏协议，回退时隐藏全屏协议, 展示商城轮询卡片（所有状态都需要） */
    if (isBack && this.isShowFqMallFullScreenProtocol) {
      this.onFullScreenProtocolApplySuccess();
      next(false);
    } else if (isBack
      && !this.isBackDialogVisible
      && !this.hasShowedBackDialog
      && this.applyStatus === OrderResultEnum.LEND_FAILED
      && !(platform.isAlipayMini || platform.isDingTalk)
    ) {
      /** 提现失败场景，回退触发挽留弹窗 */
      this.isBackDialogVisible = true;
      this.hasShowedBackDialog = true;
      this.$ubtPageButton('finance_withDrawDetails_failed_backDialog');
      next(false);
    } else if (platform.isWechatMini) {
      /** 微信小程序场景，提现结果back期望返回至首页 */
      wechat.backToHome();
    } else {
      next();
    }
  }

  // 提现失败返回挽留弹窗-下次再说
  private async onCancelChangeChannel() {
    this.isBackDialogVisible = false;
    this.$ubtPageButton('finance_withDrawDetails_failed_backDialog_cancel');
    await this.$nextTick();
    RouterHelper.backHome();
  }

  // 提现失败返回挽留弹窗-领取新额度
  private onConfirmChangeChannel() {
    this.isBackDialogVisible = false;
    this.hasShowedBackDialog = false;
    this.$ubtPageButton('finance_withDrawDetails_failed_backDialog_confirm');
    this.isNeedEducation(
      'finance_ApplyResult_ReApplyCredit',
      ['产品', this.commodityId],
      true,
    );
  }

  private callCustomService() {
    this.$ubtPageButtonNew(
      'finance_withdrawResult_customerService',
      {
        pageType: this.applyStatus,
      },
    );
    openThirdPage(customServiceUrl);
  }

  private get dialogMessage(): string {
    if (this.isAutarkySucceed()) {
      return '当前操作未成功，请稍后再试或申请其他资方，最快3分钟通过～';
    }
    if (platform.isAlipayMini || platform.isDingTalk) {
      return '';
    }
    return '别气馁！您还可以去其他渠道领取新额度，最快3分钟审核通过～';
  }

  /** 声明统一的申请新额度跳转流量分发方法，供子组件调用 */

  private getMoreCreditAmount() {
    this.$ubtPageButtonNew('finance_withdrawResult_applyAmount', {
      commodityId: this.commodityId,
      applyStatus: this.applyStatus,
    });
    if (isH5App) {
      jumpToMarketPage();
    } else {
      this.isNeedEducation(
        'finance_ApplyResult_ReApplyCredit',
        ['产品', this.commodityId],
        true,
      );
    }
  }

  /** 全屏协议授信申请提交成功，或者回退不点击领取新额度，则隐藏全屏协议 */
  private onFullScreenProtocolApplySuccess(res?: MiddleIncomeCreditApplyResponse) {
    if (res?.taskId) {
      this.middleIncomeTaskId = res.taskId;
    }
    /** 全屏协议授信申请提交成功，全屏协议隐藏 */
    this.isShowFqMallFullScreenProtocol = false;
    /** 商城轮询卡片展示 */
    this.isShowFqMallPollingCard = true;
  }

  /** 内嵌协议授信申请提交成功，内嵌协议隐藏，轮询卡片展示 */
  private onEmbeddedProtocolApplySuccess(res: MiddleIncomeCreditApplyResponse) {
    // eslint-disable-next-line no-console
    console.error('onEmbeddedProtocolApplySuccess', JSON.stringify(res));
    if (res?.taskId) {
      this.middleIncomeTaskId = res.taskId;
    }
    /** 隐藏内嵌协议模块 */
    this.isShowFqMallEmbeddedProtocol = false;
    /** 商城轮询卡片展示 */
    this.isShowFqMallPollingCard = true;
  }

  /** 渲染内嵌商城协议组件 */
  private renderCmpt() {
    if (!this.isShowFqMallEmbeddedProtocol) {
      return null;
    }
    return (
      <FqMallEmbeddedProtocol
        /** 完整分发结果 */
        dispatchResult={this.middleIncomeDispatchData}
        /** 完整协议结果 */
        protocolResult={this.middleIncomeContractListData}
        applyAmount={this.middleIncomeCreditResultData?.creditAmount || '200000'}
        from={DEFAULT_MIDDLE_INCOME_FROM}
        scene={DEFAULT_MIDDLE_INCOME_SCENE}
        /** 提现结果页 资料肯定完整，默认传false */
        incompleteInfo={false}
        on-apply-success={this.onEmbeddedProtocolApplySuccess}
        enableCountdown={this.applyStatus === OrderResultEnum.LENDING}
      />
    );
  }

  /** 渲染分期商城轮询卡片 */
  private renderMall() {
    if (!this.isShowFqMallPollingCard) {
      return null;
    }
    return (
      <InstallmentMall
        themeType={this.middleIncomeDispatchData?.agreementStyle}
        taskId={this.middleIncomeTaskId}
        on-apply={this.onInstallmentMallApply}
        from={DEFAULT_MIDDLE_INCOME_FROM}
      />
    );
  }

  /** 样式二场景，到商城卡片，立即申请，重新展示协议二样式 */
  private onInstallmentMallApply() {
    /** 商城轮询卡片展示 */
    this.isShowFqMallFullScreenProtocol = true;
  }

  private render() {
    // 渲染页面的曝光
    if (this.applyStatus) {
      const { exposeName } = this.ubtConfig[this.applyStatus] || {};
      if (exposeName) {
        this.$ubtModuleExpose(exposeName);
      }
    }
    /** loading */
    if (this.showLoadingAnimate) {
      return (
        <div class={style.pageContainerLoading}>
          <NavBar
            background-color="#fff"
            // 不需要标题
            title=" "
          />
          <div class={style.loadingContainer}>
            <LoadingAnimateComp/>
          </div>
        </div>
      );
    }

    /** 全屏协议 */
    if (this.isShowFqMallFullScreenProtocol) {
      return (
      <div class={style.pageContainerFullScreen}>
        <NavBar
          background-color="#f7f9fa"
          // 不需要标题
          title=" "
        />
        <FqMallFullScreenProtocol
          /** 完整分发结果 */
          dispatchResult={this.middleIncomeDispatchData}
          /** 完整协议结果 */
          protocolResult={this.middleIncomeContractListData}
          applyAmount={this.middleIncomeCreditResultData?.creditAmount || '200000'}
          from={DEFAULT_MIDDLE_INCOME_FROM}
          /** 提现结果页 资料肯定完整，默认传false */
          incompleteInfo={false}
          on-apply-success={this.onFullScreenProtocolApplySuccess}
        />
      </div>);
    }

    return (
      <div class={style.pageContainer}>
        {platform.isHelloApp && (
          <NavBar
            background-color="var(--page-navbar-bg-color, #fde9e5)"
            title='提现结果'
          />
        )}
        <div class={[
          style.mainContent,
          this.isShowH5Nav && style.mainContentPadding,
        ]}>
          {this.applyStatus === OrderResultEnum.LENDING && (
            <ApplyProcess
              commodityId={this.commodityId}
              showMoreCapitalInfo={this.showMoreCapitalInfo}
              financeVipType={this.financeVipType}
              pricingType={this.pricingType}
              showUpgrade={this.isAutarkyUser()}
              showPreApply={!this.isAutarkySucceed()}
              onGoPreApply={this.getMoreCreditAmount.bind(this)}
              scopedSlots={{
                contract: () => this.renderCmpt(),
                mall: () => this.renderMall(),
              }}
            />
          )}
          {this.applyStatus === OrderResultEnum.LENT && (
            <div>
              <ApplySuccess
                commodityId={this.commodityId}
                showUpgrade={this.isAutarkyUser()}
                showPreApply={!this.isAutarkySucceed()}
                onGoPreApply={this.getMoreCreditAmount.bind(this)}
                scopedSlots={{
                  contract: () => this.renderCmpt(),
                  mall: () => this.renderMall(),
                }}
              />
              <AdvApplySuccessPopup/>
            </div>
          )}
          {this.applyStatus === OrderResultEnum.LEND_FAILED && (
            <div>
              <ApplyFail
                commodityId={this.commodityId}
                commodityName={this.commodityName}
                showUpgrade={this.isAutarkyUser()}
                onGoPreApply={this.getMoreCreditAmount.bind(this)}
                scopedSlots={{
                  contract: () => this.renderCmpt(),
                  mall: () => this.renderMall(),
                }}
              />
              <AdvApplyFailPopup />
            </div>
          )}
        </div>

        <div class={style.csCenterContent}>
          <div
            class={style.csCenter}
            onClick={this.callCustomService.bind(this)}
          >
            联系客服
          </div>
        </div>

        <DialogView
          show={this.isBackDialogVisible}
          title="温馨提示"
          message={this.dialogMessage}
          closeable={false}
          closeOnPopstate={false}
          buttonType="vertical"
          confirmButtonText={this.isAutarkySucceed() ? '下次再说' : '领取新额度'}
          cancelButtonText="下次再说"
          showCancelButton={!this.isAutarkySucceed()}
          onCancel={this.onCancelChangeChannel.bind(this)}
          onConfirm={
            this.isAutarkySucceed() ? this.onCancelChangeChannel.bind(this)
              : this.onConfirmChangeChannel.bind(this)
          }
        />
      </div>
    );
  }

  private async startPolling(orderId: string, showLoading?: boolean) {
    await this.getApplyResult({ orderId, showLoading: false });

    this.pollingId = null;

    switch (this.applyStatus) {
      case OrderResultEnum.LENDING:
        setPageTitle('处理中');
        this.$ubtPageButton('臻有钱_提现结果页_提现申请中');
        // eslint-disable-next-line @typescript-eslint/no-misused-promises
        this.pollingId = setTimeout(async () => {
          await this.startPolling(orderId, false);
        }, POLLING_INTERVAL);
        break;

      case OrderResultEnum.LENT:
        setPageTitle('提现结果');
        this.$ubtPageButton('臻有钱_提现结果页_提现成功');
        break;

      case OrderResultEnum.LEND_FAILED:
        setPageTitle('提现结果');
        this.$ubtPageButton('臻有钱_提现结果页_提现失败');
        break;

      default:
        break;
    }
  }

  private beforeDestroy() {
    if (this.pollingId) {
      clearTimeout(this.pollingId);
    }
  }
}
